"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const typography_1 = require("../../shared/typography");
const react_i18next_1 = require("react-i18next");
const styled_components_1 = __importDefault(require("styled-components"));
const Wrapper = styled_components_1.default.div `
  background-color: ${({ theme }) => theme.colors.silverLighten70};
  display: flex;
  height: 100%;
  align-content: center;
  justify-content: center;
  flex-direction: column;
  div {
    max-width: 570px;
    margin: 0 auto;
    &[data-inset="true"] {
      padding: ${({ theme }) => theme.spacings.m};
    }
  }
`;
const NoMember = ({ inset = false, appCtx }) => {
    const [t] = (0, react_i18next_1.useTranslation)();
    return ((0, jsx_runtime_1.jsx)(Wrapper, { children: (0, jsx_runtime_1.jsxs)("div", { "data-inset": inset, children: [(0, jsx_runtime_1.jsx)(typography_1.H2, { children: t("dashboard.noMembers.title") }, void 0), (0, jsx_runtime_1.jsx)(typography_1.P, { children: t("dashboard.noMembers.description", {
                        appCtx: t(`common.appCtx.${appCtx === "PBP" ? "body" : "mind"}`)
                    }) }, void 0)] }, void 0) }, void 0));
};
exports.default = NoMember;
//# sourceMappingURL=NoMember.js.map